import React, { Component } from "react";

import FormatUtils from "../../utils/formatUtils";

class Endorsement extends Component {
  render() {
    return (
      <div>
        <div className={"communications-title"}>
          <span>{this.props.data.Title}</span>
        </div>
        <div className={"clear communications-desc"}>
          <span>{this.props.data.Data.Description}</span>
        </div>
        <div className={"communications-data"}>
          <div className="data-line">
            <span className={"key-data"}>Endorsement #</span>
            <span className="value-data float-right">
              {this.props.data.Data["EndorsementId"]}
            </span>
          </div>
          <div className="data-line">
            <span className={"key-data"}>Request Date</span>
            <span className="value-data float-right">
              {FormatUtils.formatDate(this.props.data.Date)}
            </span>
          </div>
          <div className="data-line">
            <span className={"key-data"}>Policy #</span>
            <span className="value-data float-right">
              {this.props.data.Data["PolicyId"]}
            </span>
          </div>
          <div className="data-line">
            <span className={"key-data"}>Policy Number</span>
            <span className="value-data float-right">
              {this.props.data.Data["PolicyNumber"]}
            </span>
          </div>
          <div className="data-line">
            <span className={"key-data"}>Carrier</span>
            <span className="value-data float-right">
              {this.props.data.Data["Carrier"]}
            </span>
          </div>
        </div>
      </div>
    );
  }
}

export default Endorsement;
